const $ = global.$ || global.jQuery || require('jquery');

/**
 * A visual component that extends the base SelectableItemSelector component to support the
 * {@link AlgorithmsModel}.
 */
import SelectableItemSelectorComponent from './selectable-item-selector';
const ID = 'algorithm-selector';

export default class AlgorithmSelectorComponent extends SelectableItemSelectorComponent {

  /**
   * Constructor.
   *
   * @param $parent JQuery object representing the parent element in which this component will be
   * inserted.
   * @param algorithmsModel the underlying model that this component visually represents.
   */
  constructor($parent, algorithmsModel) {
    super(ID, $parent, algorithmsModel);
  };

}



// WEBPACK FOOTER //
// ./src/app/map/components/algorithm-selector.js